/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import api from '../../../../services/api';
import { FaUpload } from 'react-icons/fa';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

export default function NewSentinelModal({ onClose, getList, bucket }) {
  const [files, setFiles] = useState([]);
  const [loadingForm, setLoadingForm] = useState(false);

  const handleOnCloseModal = () => {
    setFiles([])
    onClose()
  }

  const handleSubmit = async () => {
    setLoadingForm(true);
    if (files.length <= 0) {
      setLoadingForm(false);
      return enqueueSnackbar('Selecione um arquivo sentinela para upload.', { variant: 'error' });
    }

    try {
      for (let i = 0; i < files.length; i++) {
        // GET SIGNED URL
        const filename = files[i].name;
        const contentType = 'appication/pdf';

        const response = await api.get(`/lake/signed-url?filename=${filename}&contentType=${contentType}&bucket=${bucket}`);
        const signedUrl = response.data.uploadURL;

        // UPLOAD BINARY FILE
        const axiosS3 = axios.create()
        delete axiosS3.defaults.headers.put['Content-Type']

        await axiosS3.put(signedUrl, files[i],
          {
            headers: { 'Content-Type': contentType }
          }
        )
      }

      enqueueSnackbar('Arquivo adicionado com sucesso!', { variant: 'success' });
      
      // CLEANUP AND CLOSE
      setLoadingForm(false);
      setFiles([]);
      handleOnCloseModal();
      
    } catch (error) {
      console.log('SENTINELAS/NEW-MODAL - ERROR UPLOADING FILE', error);
      setLoadingForm(false);
      enqueueSnackbar('Erro ao carregar arquivo!', { variant: 'error' });
    } finally {
      getList()
    }
  }

  const handleChangeFile = async (events) => {
    let uploadFiles = [...files];
    for (const [key, value] of Object.entries(events)) {
      console.log( value)
      if (value.type !== "application/pdf") {
        enqueueSnackbar('Somente arquivo PDF.', { variant: 'error' });
        return
        }
        uploadFiles.push(value)
      }
    setFiles(uploadFiles)
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Adicionar sentinela
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>

        <Box>
          <label
            id="thumbnail"
            className={files ? 'has-thumbnail' : ''}
          >
            {files.length > 0 ?
              <div className="divFile" id="divFile">
                <FaUpload style={{ paddingRight: 5 }} />
                <span>Adicionar outro arquivo</span>
              </div>
              :
              <div className="divFile" id="divFile">
                <FaUpload style={{ paddingRight: 5 }} />
                <span>Escolha o arquivo</span>
              </div>
            }
            <input
              type="file"
              multiple
              accept="application/pdf"
              onChange={event => handleChangeFile(event.target.files)}
            />
          </label>

          <Box>
            {files.map((file, index) => {
              return (
                <p key={index}>
                  {file.name}
                </p>
              )
            })}
          </Box>
        </Box>

      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button disabled={loadingForm} variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSubmit()}>
            {loadingForm? <CircularProgress color='success' /> : 'Carregar'}
          </Typography>
        </Button>
        <Button disabled={loadingForm} variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
